import Masonry from "react-responsive-masonry";
import { useAppQuery } from "../../../../http/useAppQuery.ts";
import type { InspirationContent } from "../../../types.ts";
import { InspirationTile } from "./InspirationTile.tsx";

export const InspirationLibrarySection = () => {
  const { data: curatedContents } = useAppQuery<InspirationContent[]>({
    queryKey: "inspirations/contents",
  });

  if (curatedContents?.length === 0 || !curatedContents) return null;

  return (
    <div className="flex-col">
      <div className="min-h-1600 py-400 flex-row items-center justify-between">
        <div className="flex-col gap-100">
          <div className="heading-2xl">Explore creations</div>
        </div>
      </div>
      <div className="rounded-400 overflow-hidden">
        <Masonry columnsCount={5} gutter="1px">
          {curatedContents.map((content) => (
            <InspirationTile key={content.uuid} content={content} />
          ))}
        </Masonry>
      </div>
    </div>
  );
};
